import React, {useMemo} from 'react'
import styles from './UIGameTradeCreatorProposal.module.scss'
import {Avatar} from '../../../common/Avatar/index.ts'
import {type CardEnum} from '@colonist/game-states'
import IconTradeArrowGreen from '@static/images/icon_trade_arrow_green.svg'
import {cardEnumsToCardState} from '../../../utils/cards.ts'
import {UIGameCardInventory} from '../../../common/UIGameCardInventory/UIGameCardInventory.tsx'
import {LobbyImage} from '@colonist/types'
import {TradeErrorHighlightLocationEnum} from '@colonist/game-mechanic-validators'
import {usePlayerValidators} from '../../../store/selectors/usePlayerValidators.ts'
import {useGameStore} from '../../../store/GameStoreContext.ts'
import {useCardsToHighlight} from '../useCardsToHighlight.ts'
import {useCurrentStateValidator} from '../../../store/selectors/useCurrentStateValidator.ts'

export const UIGameTradeCreatorProposalWantedHalf = ({
    wantedCards,
    onClickWantedCard,
    isPortraitLayout,
}: {
    wantedCards: CardEnum[]
    onClickWantedCard: (card: CardEnum) => void
    isPortraitLayout?: boolean | undefined
}) => {
    const gameState = useGameStore((state) => state.gameState)
    const myColor = useGameStore((state) => state.myColor)
    const {getPlayerValidator} = usePlayerValidators()
    const currentStateValidator = useCurrentStateValidator()
    const isMyTurn = currentStateValidator.currentTurnPlayers.includes(myColor)
    const isTradeWithAllPlayers = isMyTurn
    const currentTurnPlayerColor = currentStateValidator.currentTurnPlayers[0]
    const currentTurnPlayerValidator = getPlayerValidator(currentTurnPlayerColor)
    const wantedCardsState = useMemo(() => cardEnumsToCardState(wantedCards), [wantedCards])
    const cardsToHighlight = useCardsToHighlight(TradeErrorHighlightLocationEnum.ProposalWanted)

    return (
        <div className={styles.proposalWantedHalfContainer}>
            {isTradeWithAllPlayers ? <Avatar
                image={LobbyImage.Players}
                hideBackground
                className={styles.avatar}
            /> : <Avatar
                image={currentTurnPlayerValidator.displayIcon}
                color={currentTurnPlayerColor}
                profilePictureUrl={currentTurnPlayerValidator.profilePictureUrl}
                className={styles.avatar}
            /> }
            <img src={IconTradeArrowGreen} className={styles.givingArrow}/>
            <div className={styles.cardStackContainer}>
                <UIGameCardInventory
                    showTipTitle={false}
                    showTipBody={false}
                    cardState={wantedCardsState}
                    onClickCard={onClickWantedCard}
                    animate
                    enablePartition
                    className={styles.cardStack}
                    cardSize={isPortraitLayout ? 'sm' : 'base'}
                    cardsToHighlight={cardsToHighlight}/>
            </div>
        </div>
    )
}
